import {
  addDays,
  addWeeks,
  endOfISOWeek,
  endOfMonth,
  format,
  startOfISOWeek,
  startOfMonth,
} from 'date-fns';
import { getUtcStartOfDay } from 'server/shared/helpers/removeTimeZoneOffset';
import { dbDayDateToken } from 'server/static/dbDayDateToken';

export function getJobsRangeQuery(
  range: string | undefined,
): Mongo.Selector<{ date: string }> | undefined {
  if (!range || range === 'ALL') {
    return undefined;
  }

  const splitRange = range.split(',');
  switch (splitRange[0]) {
    case 'TODAY': {
      return {
        date: format(getUtcStartOfDay(new Date()), dbDayDateToken),
      };
    }
    case 'TOMORROW': {
      return {
        date: format(getUtcStartOfDay(addDays(new Date(), 1)), dbDayDateToken),
      };
    }
    case 'WEEK': {
      return {
        date: {
          $gte: format(
            getUtcStartOfDay(startOfISOWeek(new Date())),
            dbDayDateToken,
          ),
          $lte: format(
            getUtcStartOfDay(endOfISOWeek(new Date())),
            dbDayDateToken,
          ),
        },
      };
    }
    case 'NEXT_WEEK': {
      return {
        date: {
          $gte: format(
            getUtcStartOfDay(startOfISOWeek(addWeeks(new Date(), 1))),
            dbDayDateToken,
          ),
          $lte: format(
            getUtcStartOfDay(endOfISOWeek(addWeeks(new Date(), 1))),
            dbDayDateToken,
          ),
        },
      };
    }
    case 'MONTH': {
      return {
        date: {
          $gte: format(
            getUtcStartOfDay(startOfMonth(new Date())),
            dbDayDateToken,
          ),
          $lte: format(
            getUtcStartOfDay(endOfMonth(new Date())),
            dbDayDateToken,
          ),
        },
      };
    }
    case 'CUSTOM': {
      if (splitRange[1] && splitRange[2]) {
        return {
          date: {
            $gte: splitRange[1],
            $lte: splitRange[2],
          },
        };
      }
      return undefined;
    }
    default:
      return undefined;
  }
}
